import React from 'react'
import { string, object, bool, shape } from 'prop-types'
import { EventTieredSponsor } from '@/component/Primitive/Events'
import generateSponsorImages from './lib/sponsor-image-generator'

const EventTieredSponsorWidget = ({ sponsor, pageData, size, ...other }) => {
  const { eventUmbrella } = pageData
  if (!sponsor) return null
  const { image, logo } = generateSponsorImages(
    [sponsor?.images],
    sponsor?.tier
  )
  sponsor = {
    ...sponsor,
    image,
    logo
  }
  const createEventUrl = (path) =>
    'events/' +
    eventUmbrella?.slug +
    '/' +
    eventUmbrella?.event?.slug +
    '/sponsor/' +
    path

  const fullUrlPath = sponsor.enableSponsorBooth && createEventUrl(sponsor.slug)
  return (
    <EventTieredSponsor
      {...sponsor}
      {...other}
      tier={sponsor.tier}
      fullUrlPath={fullUrlPath}
      size={size}
    />
  )
}

EventTieredSponsorWidget.propTypes = {
  theme: string,
  inverse: bool,
  size: string,
  sponsor: object,
  pageData: shape({
    eventUmbrella: shape({
      event: shape({
        slug: string
      })
    })
  })
}

export default EventTieredSponsorWidget
